const debug = process.env.NODE_ENV !== 'production';

export function getBaseURL() {
    if (debug) {
        return 'http://127.0.0.1:8015/';
    } else {
        return 'https://api.webdom.com.br/';
    }
}

export function getBaseURLAPI_TOW() {
    if (debug) {
        return 'http://127.0.1.1:5002/';
    } else {
        return 'https://api-two.webdom.com.br/';
    }
}

export function getDominio() {
    return window.location.hostname;
}

export const API_ONE = 'https://api-one.webdom.com.br/api/';
export const API_HTML = 'https://diario-html.webdom.com.br/';
export const API_TOW = getBaseURLAPI_TOW();
